import { env } from "src/env/development";

export function suffixFormatter(suffix: any): string | null {
    if (env.validSuffix.includes(suffix) === false) {
        return null
    }
    return suffix;
}